import { FC, useState } from 'react';
import { Button } from '@heroui/react';
import Portfolio from '../../../features/portfolio/Portfolio';
import Filter from '../../../features/filter/Filter';
import { useAppDispatch } from '../../../core/rootHooks';
import { AppDispatch } from '../../../core/store';
import { setSelectedPortfolioRequest } from '../../../features/portfolio/portfolioSlice';
import { setSelectedFilterRequest } from '../../../features/filter/filterSlice';
import { BsSliders, BsCardList } from 'react-icons/bs';
import { ILeftSidebarButton } from './leftSidebarTypes';

const CustomFilterMenu: FC = () => {
	const dispatch = useAppDispatch<AppDispatch>();
	const [activeLeftSidebarMenu, setActiveLeftSidebarMenu] = useState('');

	const renderPanel = () => {
		return (
			<div className="panel">
				{activeLeftSidebarMenu === 'filter' && <Filter setActiveLeftSidebarMenu={setActiveLeftSidebarMenu} />}
				{activeLeftSidebarMenu === 'custom-portfolio' && <Portfolio setActiveLeftSidebarMenu={setActiveLeftSidebarMenu} />}
				{/* {activeLeftSidebarMenu === 'date-range' && <DateRange setActiveLeftSidebarMenu={setActiveLeftSidebarMenu} />} */}
			</div>
		);
	};

	return (
		<>
			<div className="sidebar flex flex-col fixed space-y-2 w-20 h-28 justify-end z-50">
				<LeftSidebarButton
					icon={<BsSliders size={40} color={`${activeLeftSidebarMenu === 'filter' ? '#569FD3' : '#FFFFFF'} `} />}
					label="FILTER"
					isActive={activeLeftSidebarMenu === 'filter'}
					handleLeftSidebarMenuButtonOnClick={() => {
						dispatch(setSelectedPortfolioRequest({ id: null }));
						setActiveLeftSidebarMenu('filter');
					}}
				/>

				<LeftSidebarButton
					icon={<BsCardList size={42} color={`${activeLeftSidebarMenu === 'custom-portfolio' ? '#569FD3' : '#FFFFFF'} `} />}
					label="CUSTOM PORTFOLIO"
					isActive={activeLeftSidebarMenu === 'custom-portfolio'}
					handleLeftSidebarMenuButtonOnClick={() => {
						dispatch(setSelectedFilterRequest({ id: null }));
						setActiveLeftSidebarMenu('custom-portfolio');
					}}
				/>

				{/* <LeftSidebarButton
					icon={<BsClock size={42} color={`${activeLeftSidebarMenu === 'date-range' ? '#569FD3' : '#FFFFFF'} `} />}
					label="DATE RANGE"
					isActive={activeLeftSidebarMenu === 'date-range'}
					handleLeftSidebarMenuButtonOnClick={() => {
						dispatch(setSelectedFilterRequest({ id: null }));
						setActiveLeftSidebarMenu('date-range');
					}}
				/> */}
			</div>

			{renderPanel()}
		</>
	);
};

export default CustomFilterMenu;

const LeftSidebarButton: FC<ILeftSidebarButton> = ({ icon, isActive, handleLeftSidebarMenuButtonOnClick }) => (
	<Button
		isIconOnly
		className={`w-full h-full  rounded-none ${isActive ? 'bg-msi-white-color' : 'bg-msi-midblue-color-500'}`}
		onPress={handleLeftSidebarMenuButtonOnClick}
		style={isActive ? { width: '88px' } : {}}
	>
		{icon}
	</Button>
);
